<template lang="pug">
#relatorio-exportacao-tabela
    .tabela-relatorio-exportacao
        el-table(
            :key="listagemTableKey('relatorio', tabelaData, paginacao.pagina + 1)",
            :data='tabelaData',
            ref='relatorio-exportacao-table',
            v-loading='carregando',
            stripe,
            :default-sort='{ prop: "dataAverbacao", order: "descending" }',
            @sort-change='sortChangeRequest',
            style='width: 100%',
        )
            el-table-column(
                prop='idExterno',
                :label='$t("relatorioExportacao.lista.numeroBL")',
                align='left',
            )

            el-table-column(
                prop='navio',
                :label='$t("relatorioExportacao.lista.navio")',
                align='left',
                width='250',
                sortable
            )

            el-table-column(
                prop='dataAverbacao',
                :label='$t("relatorioExportacao.lista.dataAverbacao")',
                align='left',
                width='250',
                sortable
            )
                template(slot-scope='scope')
                    | {{ formatarData(scope.row.dataAverbacao) }}

            el-table-column(
                prop='qtdContratos',
                :label='$t("relatorioExportacao.lista.qtdContratos")',
                align='left',
                width='250',
                sortable
            )

            el-table-column(
                prop='qtdPropriedades',
                :label='$t("relatorioExportacao.lista.qtdCars")',
                align='left',
                width='250',
                sortable
            )

            el-table-column(
                :label='$t("denuncia.table.columns.actions")',
                align='center',
                width='100'
            )
                .template.d-flex.justify-content-center.tabela-gestao-icone(
                    slot-scope='scope'
                )
                    el-dropdown.action-button(trigger='click')
                        span.el-dropdown-link
                            i.mdi.mdi-dots-vertical
                        el-dropdown-menu(slot='dropdown')
                            el-dropdown-item(
                                icon='el-icon-view',
                                @click.native='visualizarDetalhe(scope.row.id)'
                            )
                                | {{ $t('relatorioExportacao.lista.visualizarDetalhe') }}

            template(slot='empty')
                el-empty(:description='$t("relatorioExportacao.lista.listaVazia")')

    .tabela-relatorio-exportacao__paginacao
        span.pagina
            | {{ paginacao.total }} {{ paginacao.total > 1 ? $t('relatorioExportacao.lista.listaVazia') : $t('relatorioExportacao.lista.listaVazia') }}

        el-pagination(
            background,
            :page-size='paginacao.itensPorPagina',
            :pager-count='5',
            :current-page.sync='paginacao.pagina + 1',
            layout='prev, pager, next',
            :total='paginacao.total',
            @current-change='mudarPagina'
        )
</template>

<script>
import { formatarData } from '@/modules/relatorio-exportacao/utils';

export default {
    name: 'DenunciaTabelaGestao',
    props: {
        tabelaData: {
            type: Array,
            required: true
        },
        paginacao: {
            type: Object,
            required: true
        },
        carregando: {
            type: Boolean,
            required: false
        }
    },
    methods: {
        formatarData,
        mudarPagina(novaPagina) {
            this.$emit('mudarPagina', novaPagina - 1);
        },
        sortChangeRequest(column) {
            const order = {
                prop: column.prop,
                order: column.order === 'ascending' ? 'asc' : 'desc'
            };

            this.$emit('ordenarTabela', order);
        },
        visualizarDetalhe(id) {
            this.$router.push({
                name: 'RelatorioExportacaoDetalhe',
                params: { id }
            });
        }
    }
};
</script>
<style lang="scss">
#relatorio-exportacao-tabela {
    box-shadow: 0 0 10px rgb(0 0 0 / 10%);
    border-radius: 10px;

    .el-table {
        border-top-right-radius: 11px;
        border-top-left-radius: 11px;
        min-height: 240px;

        thead.has-gutter {
            height: 67px;

            th.el-table__cell {
                background-color: #fbfbfb;
            }
        }
    }

    .el-table__cell {
        font-size: 12px;
    }

    .is-leaf {
        font-size: 13px;
    }

    .status-processamento {
        max-width: 148px;
        word-break: break-word;
        font-size: 13px;
        line-height: 17px;
    }

    .tabela-relatorio-exportacao__paginacao {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: var(--white);
        padding: 14px 11px;
        border-bottom-left-radius: 11px;
        border-bottom-right-radius: 11px;

        .pagina {
            color: var(--primary);
            font-weight: 600;
        }
    }

    .tabela-gestao-icone {
        i {
            font-size: 23px;
            cursor: pointer;
        }
    }
}
</style>
